<article class="entry entry-display mb-2">
    <figure class="entry-media banner-overlay overlay-dark" [style.padding-top]="paddingTop">
        <a [routerLink]="['/blog/single/default/' + post.slug]">
            <molla-image [src]="SERVER_URL + post.image[0].url" alt="image desc" [fixedPt]="paddingTop"></molla-image>
        </a>
    </figure>

    <div class="entry-body text-center">
        <div class="entry-meta">
            <a [routerLink]="['/blog/single/default/' + post.slug]">{{ post.date | date : 'mediumDate' }}</a>,&nbsp;
            <a [routerLink]="['/blog/single/default/' + post.slug]">{{ post.comments }} Comments</a>
        </div>

        <h2 class="entry-title">
            <a [routerLink]="['/blog/single/default/' + post.slug]">{{ post.title }}</a>
        </h2>

        <div class="entry-content">
            <a [routerLink]="['/blog/single/default/' + post.slug]" class="read-more">Read More</a>
        </div>
    </div>
</article>